/** ui-foundation brand-600 (`bg-brand-solid` on primary buttons). */
export const DASHBOARD_PRIMARY_BLUE = "#0164EA";

/** Spend breakdown palette aligned with dashboard design. */
export const SPEND_CHART_COLORS = [DASHBOARD_PRIMARY_BLUE, "#22C55E", "#334155", "#F97316", "#EC4899", "#94A3B8"] as const;

/** Charge item status palette for stacked bar chart. */
export const CHARGE_STATUS_COLORS = {
    notAddedToReport: DASHBOARD_PRIMARY_BLUE,
    addedToReport: "#22C55E",
    review: "#475569",
    accountingReview: "#F97316",
    approved: "#EC4899",
} as const;
